import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NextSeo } from 'next-seo';

import ReviewList from '../components/Review/ReviewList';
import EmptyState from '../components/Common/EmptyState';

class Favourites extends Component {
    render() {
        const { userDetails } = this.props;
        const { loadingUserDetails } = this.props.loadingState;
        return (
            <div>
                <NextSeo
                    title='Accelerated Web Player Favourites'
                    description='Find your favourite episodes here.'
                    canonical='https://tedapp.ai/favourites'
                    noindex={true}
                    nofollow={true}
                    // openGraph={{
                    //     type: 'website',
                    //     locale: 'en_IE',
                    //     url: 'https://tedapp.ai/favourites',
                    //     site_name: 'Accelerated',
                    // }}
                // twitter:{
                //     handle: '@handle',
                //     site: '@site',
                //     cardType: 'summary_large_image',
                // }
                />
                <h2>Favourites</h2>
                {!loadingUserDetails && !userDetails &&
                    <EmptyState message="Your favourite episodes will show up here." imageName="favourites" />
                }
                <ReviewList />
            </div>
        )
    }
}

Favourites.propTypes = {
    loadingState: PropTypes.object,
    loadingUserDetails: PropTypes.bool,
    fetchError: PropTypes.object,
    userDetails: PropTypes.object,
    // getEpisodesRecent: PropTypes.func,
    // getEpisodeReviews: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        fetchError: state.errorsState,
    }
}

export default connect(mapStateToProps, null)(Favourites);
